unit DashboardMethods;

interface

uses
  WEBLib.Grids,
  App.Enumerations;

type
  TMissingEmailType = (
    ptAcademy,
    ptSchool
  );

  TPaymentTableData = record
    PaymentTotal: Double;
    PaymentSchoolCount: Integer;

    TotalSchoolCount: Integer;

    AveragePayment: Double;

    RemittanceTotal: Double;
    RemittanceSchoolCount: Integer;

  end;

  TPaymentByTypeTableData = record
    TotalPaymentValue: Double;
    TotalPaymentCount: Integer;
    TotalSchoolCount: Integer;

    PrimaryCount: Integer;
    SecondaryCount: Integer;
    IndependentCount: Integer;

  end;


const
  Missing_Email_Type: array[TMissingEmailType] of string = ('Academy', 'School');

  JSONDateFormat = 'yyyy-mm-dd';

type
  TDashboardMethods = class
  private
    FAllowProcessing: Boolean;

    FFromDate, FToDate: TDateTime;

  // standard processing
  public
    procedure UpdateTableCell(DataTable: TTableControl; Row: Integer; Col: Integer; Value: string);
    procedure UpdateTableRow(DataTable: TTableControl; Row: Integer; Values: array of string);

    procedure UpdatePercentage(DataTable: TTableControl; ColumnIndex: Integer; RowHeader: string; Value, Count: Integer);
    procedure UpdateAverage(DataTable: TTableControl; ColumnIndex: Integer; RowHeader: string; Value: Double; Count: Integer);

    function GetFromDateString: string;
    function GetToDateString: string;

    // properties
    property AllowProcessing: Boolean read FAllowProcessing write FAllowProcessing;

    property FromDate: TDateTime read FFromDate write FFromDate;
    property ToDate: TDateTime read FToDate write FToDate;

    property FromDateString: string read GetFromDateString;
    property ToDateString: string read GetToDateString;

  // school status
  private
    FData_SchoolStatus: array[TSchoolStatus] of Integer;

    function GetSchoolStatusData(Index: TSchoolStatus): Integer;
    procedure SetSchoolStatusData(Index: TSchoolStatus; Value: Integer);

  public
    [async]
    procedure RefreshData_SchoolStatus; async;

    property SchoolStatusData[Index: TSchoolStatus]: Integer read GetSchoolStatusData write SetSchoolStatusData;

  // school kind
  private
    FData_SchoolKind: array[TSchoolKind] of Integer;

    function GetSchoolKindData(Index: TSchoolKind): Integer;
    procedure SetSchoolKindData(Index: TSchoolKind; Value: Integer);

  public
    [async]
    procedure RefreshData_SchoolKind; async;

    property SchoolKindData[Index: TSchoolKind]: Integer read GetSchoolKindData write SetSchoolKindData;

  // school kind - pupil count
  private
    FData_SchoolKindPupilCount: array[TSchoolKind] of Integer;

    function GetSchoolKindPupilCountData(Index: TSchoolKind): Integer;
    procedure SetSchoolKindPupilCountData(Index: TSchoolKind; Value: Integer);

  public
    [async]
    procedure RefreshData_SchoolKindPupilCount; async;

    property SchoolKindPupilCountData[Index: TSchoolKind]: Integer read GetSchoolKindPupilCountData write SetSchoolKindPupilCountData;

  // missing email data
  private
    FData_MissingEmails: array[TMissingEmailType] of Integer;

    function GetMissingEmailCountData(Index: TMissingEmailType): Integer;
    procedure SetMissingEmailCountData(Index: TMissingEmailType; Value: Integer);

  public
    [async]
    procedure RefreshData_MissingEmailCount; async;

    property MissingEmailCountData[Index: TMissingEmailType]: Integer read GetMissingEmailCountData write SetMissingEmailCountData;

  // payment table data
  private
    FData_PaymentTable: TPaymentTableData;

  public
    [async]
    procedure RefreshData_PaymentTable; async;

    property PaymentTableData: TPaymentTableData read FData_PaymentTable write FData_PaymentTable;

  // bacs table data
  private
    FData_BACSTable: TPaymentByTypeTableData;

  public
    [async]
    procedure RefreshData_BACSTable; async;

    property BACSTableData: TPaymentByTypeTableData read FData_BACSTable write FData_BACSTable;

  // cheque table data
  private
    FData_ChequeTable: TPaymentByTypeTableData;

  public
    [async]
    procedure RefreshData_ChequeTable; async;

    property ChequeTableData: TPaymentByTypeTableData read FData_ChequeTable write FData_ChequeTable;

  end;

var
  dashboardMethod: TDashboardMethods;

implementation

uses
  System.SysUtils,
  MainDataModule,
  XData.Web.Client,
  Rtti,
  JS,
  CRM.Enumerations;

// standard processing
procedure TDashboardMethods.UpdateTableCell(DataTable: TTableControl; Row: Integer; Col: Integer; Value: string);
begin
  if not FAllowProcessing then
    Exit;

  while (DataTable.RowCount - 1) < Row do
    DataTable.RowCount := DataTable.RowCount + 1;

  DataTable.Cells[Col, Row] := Value;

end;

procedure TDashboardMethods.UpdateTableRow(DataTable: TTableControl; Row: Integer; Values: array of string);
var
  iIdx: Integer;

begin
  if not FAllowProcessing then
    Exit;

  for iIdx := Low(Values) to High(Values) do
    UpdateTableCell(DataTable, Row, iIdx, Values[iIdx]);

end;

procedure TDashboardMethods.UpdatePercentage(DataTable: TTableControl; ColumnIndex: Integer; RowHeader: string; Value, Count: Integer);
begin
  if (Value = 0) or (Count = 0) then
    UpdateTableRow(DataTable, ColumnIndex, [RowHeader, Format('%0.2f', [0])])
  else
    UpdateTableRow(DataTable, ColumnIndex, [RowHeader, Format('%0.2f', [(Value / Count * 100)])]);

end;

procedure TDashboardMethods.UpdateAverage(DataTable: TTableControl; ColumnIndex: Integer; RowHeader: string; Value: Double; Count: Integer);
begin
  if (Value = 0) or (Count = 0) then
    UpdateTableRow(DataTable, ColumnIndex, [RowHeader, '£0'])
  else
    UpdateTableRow(DataTable, ColumnIndex, [RowHeader, Format('£%m', [(Value / Count)])]);

end;


function TDashboardMethods.GetFromDateString: string;
begin
  Result := FormatDateTime(JSONDateFormat, FFromDate);

end;

function TDashboardMethods.GetToDateString: string;
begin
  Result := FormatDateTime(JSONDateFormat, FToDate);

end;

// school status
function TDashboardMethods.GetSchoolStatusData(Index: TSchoolStatus): Integer;
begin
  Result := FData_SchoolStatus[Index];

end;

procedure TDashboardMethods.SetSchoolStatusData(Index: TSchoolStatus; Value: Integer);
begin
  FData_SchoolStatus[Index] := Value;

end;

procedure TDashboardMethods.RefreshData_SchoolStatus;
const
  ServiceContract = 'ISchoolService.GetSchoolCountBySchoolStatus';

var
  lRetVal: TXDataClientResponse;

  oSchoolStatus: TSchoolStatus;

begin
  for oSchoolStatus := TSchoolStatus.New to TSchoolStatus.GoneAway do
  begin
    if not FAllowProcessing then
      Exit;

    lRetVal := Await(
      TXDataClientResponse,
      MainData.WebClient.RawInvokeAsync(
        ServiceContract,
        [TRttiEnumerationType.GetName<TSchoolStatus>(oSchoolStatus)]
      )
    );
    SchoolStatusData[oSchoolStatus] := JS.toInteger(lRetval.ResultAsObject['value']);

  end;

end;

// school kind
function TDashboardMethods.GetSchoolKindData(Index: TSchoolKind): Integer;
begin
  Result := FData_SchoolKind[Index];

end;

procedure TDashboardMethods.SetSchoolKindData(Index: TSchoolKind; Value: Integer);
begin
  FData_SchoolKind[Index] := Value;

end;

procedure TDashboardMethods.RefreshData_SchoolKind;
const
  ServiceContract = 'ISchoolService.GetSchoolCountBySchoolKind';

var
  lRetVal: TXDataClientResponse;

  oSchoolKind: TSchoolKind;

begin
  for oSchoolKind := TSchoolKind.Primary to TSchoolKind.Independent do
  begin
    if not FAllowProcessing then
      Exit;

    lRetVal := Await(
      TXDataClientResponse,
      MainData.WebClient.RawInvokeAsync(
        ServiceContract,
        [TRttiEnumerationType.GetName<TSchoolKind>(oSchoolKind)]
      )
    );
    SchoolKindData[oSchoolKind] := JS.toInteger(lRetval.ResultAsObject['value']);

  end;

end;

// school kind - pupil count
function TDashboardMethods.GetSchoolKindPupilCountData(Index: TSchoolKind): Integer;
begin
  Result := FData_SchoolKindPupilCount[Index];

end;

procedure TDashboardMethods.SetSchoolKindPupilCountData(Index: TSchoolKind; Value: Integer);
begin
  FData_SchoolKindPupilCount[Index] := Value;

end;

procedure TDashboardMethods.RefreshData_SchoolKindPupilCount;
const
  ServiceContract = 'ISchoolService.GetPupilCountBySchoolKind';

var
  lRetVal: TXDataClientResponse;

  oSchoolKind: TSchoolKind;

begin
  for oSchoolKind := TSchoolKind.Primary to TSchoolKind.Independent do
  begin
    if not FAllowProcessing then
      Exit;

    lRetVal := Await(
      TXDataClientResponse,
      MainData.WebClient.RawInvokeAsync(
        ServiceContract,
        [TRttiEnumerationType.GetName<TSchoolKind>(oSchoolKind)]
      )
    );
    SchoolKindPupilCountData[oSchoolKind] := JS.toInteger(lRetval.ResultAsObject['value']);

  end;

end;

// missing email data
function TDashboardMethods.GetMissingEmailCountData(Index: TMissingEmailType): Integer;
begin
  Result := FData_MissingEmails[Index];

end;

procedure TDashboardMethods.SetMissingEmailCountData(Index: TMissingEmailType; Value: Integer);
begin
  FData_MissingEmails[Index] := Value;

end;

procedure TDashboardMethods.RefreshData_MissingEmailCount;
const
  ServiceContracts: array[TMissingEmailType] of string = (
    'IAcademyService.GetMissingEmailCount',
    'ISchoolService.GetMissingEmailCount'
  );

var
  lRetVal: TXDataClientResponse;

  oEmailType: TMissingEmailType;

begin
  if not FAllowProcessing then
    Exit;

  for oEmailType := TMissingEmailType.ptAcademy to TMissingEmailType.ptSchool do
  begin
    lRetval := Await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync(ServiceContracts[oEmailType], [Missing_Email_Type[oEmailType]]));
    FData_MissingEmails[oEmailType] := JS.toInteger(lRetval.ResultAsObject['value']);

  end;

end;

// payment table data
procedure TDashboardMethods.RefreshData_PaymentTable;
const
  SC_GetPaymentAmountBetweenDates = 'IMoneyService.GetPaymentAmountBetweenDates';
  SC_GetSchoolTotalCount = 'ISchoolService.GetSchoolTotalCount';
  SC_GetPaymentSchoolCountBetweenDates = 'IMoneyService.GetPaymentSchoolCountBetweenDates';
  SC_GetRemittanceAmountBetweenDates = 'IMoneyService.GetRemittanceAmountBetweenDates';
  SC_GetRemittanceSchoolCountBetweenDates = 'IMoneyService.GetRemittanceSchoolCountBetweenDates';

var
  lRetVal: TXDataClientResponse;

begin
  if not FAllowProcessing then
    Exit;

  lRetVal := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      SC_GetSchoolTotalCount,
      [FromDateString, ToDateString]
    )
  );
  PaymentTableData.TotalSchoolCount := JS.toInteger(lRetval.ResultAsObject['value']);

  lRetVal := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      SC_GetPaymentAmountBetweenDates,
      [FromDateString, ToDateString]
    )
  );
  PaymentTableData.PaymentTotal := JS.toNumber(lRetval.ResultAsObject['value']);

  lRetVal := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      SC_GetPaymentSchoolCountBetweenDates,
      [FromDateString, ToDateString]
    )
  );
  PaymentTableData.PaymentSchoolCount := JS.toInteger(lRetval.ResultAsObject['value']);

  lRetVal := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      SC_GetRemittanceAmountBetweenDates,
      [FromDateString, ToDateString]
    )
  );
  PaymentTableData.RemittanceTotal := JS.toNumber(lRetval.ResultAsObject['value']);

  lRetVal := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      SC_GetRemittanceSchoolCountBetweenDates,
      [FromDateString, ToDateString]
    )
  );
  PaymentTableData.RemittanceSchoolCount := JS.toInteger(lRetval.ResultAsObject['value']);

end;

// bacs table data
procedure TDashboardMethods.RefreshData_BACSTable;
const
  SC_GetPaymentCountByPaymentMethod = 'IMoneyService.GetPaymentCountByPaymentMethod';

  SC_GetPaymentMethodSchoolCountBetweenDates = 'IMoneyService.GetPaymentMethodSchoolCountBetweenDates';
  SC_GetPaymentMethodSchoolCountByKindBetweenDates = 'IMoneyService.GetPaymentMethodSchoolCountByKindBetweenDates';
  SC_GetPaymentAmountByPaymentMethodBetweenDates = 'IMoneyService.GetPaymentAmountByPaymentMethodBetweenDates';

var
  lRetVal: TXDataClientResponse;

begin
  if not FAllowProcessing then
    Exit;

  lRetVal := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      SC_GetPaymentAmountByPaymentMethodBetweenDates,
      [Payment_Method[TPaymentMethod.BACS], FromDateString, ToDateString]
    )
  );
  BACSTableData.TotalPaymentValue := JS.toNumber(lRetval.ResultAsObject['value']);

  lRetVal := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      SC_GetPaymentCountByPaymentMethod,
      [Payment_Method[TPaymentMethod.BACS], FromDateString, ToDateString]
    )
  );
  BACSTableData.TotalPaymentCount := JS.toInteger(lRetval.ResultAsObject['value']);

  lRetVal := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      SC_GetPaymentMethodSchoolCountBetweenDates,
      [Payment_Method[TPaymentMethod.BACS], FromDateString, ToDateString]
    )
  );
  BACSTableData.TotalSchoolCount := JS.toInteger(lRetval.ResultAsObject['value']);

  lRetVal := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      SC_GetPaymentMethodSchoolCountByKindBetweenDates,
      [Payment_Method[TPaymentMethod.BACS], School_Kind[TSchoolKind.Primary], FromDateString, ToDateString]
    )
  );
  BACSTableData.PrimaryCount := JS.toInteger(lRetval.ResultAsObject['value']);

  lRetVal := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      SC_GetPaymentMethodSchoolCountByKindBetweenDates,
      [Payment_Method[TPaymentMethod.BACS], School_Kind[TSchoolKind.Secondary], FromDateString, ToDateString]
    )
  );
  BACSTableData.SecondaryCount := JS.toInteger(lRetval.ResultAsObject['value']);

  lRetVal := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      SC_GetPaymentMethodSchoolCountByKindBetweenDates,
      [Payment_Method[TPaymentMethod.BACS], School_Kind[TSchoolKind.Independent], FromDateString, ToDateString]
    )
  );
  BACSTableData.IndependentCount := JS.toInteger(lRetval.ResultAsObject['value']);

end;

// Cheque table data
procedure TDashboardMethods.RefreshData_ChequeTable;
const
  SC_GetPaymentCountByPaymentMethod = 'IMoneyService.GetPaymentCountByPaymentMethod';

  SC_GetPaymentMethodSchoolCountBetweenDates = 'IMoneyService.GetPaymentMethodSchoolCountBetweenDates';
  SC_GetPaymentMethodSchoolCountByKindBetweenDates = 'IMoneyService.GetPaymentMethodSchoolCountByKindBetweenDates';
  SC_GetPaymentAmountByPaymentMethodBetweenDates = 'IMoneyService.GetPaymentAmountByPaymentMethodBetweenDates';

var
  lRetVal: TXDataClientResponse;

begin
  if not FAllowProcessing then
    Exit;

  lRetVal := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      SC_GetPaymentAmountByPaymentMethodBetweenDates,
      [Payment_Method[TPaymentMethod.Cheque], FromDateString, ToDateString]
    )
  );
  ChequeTableData.TotalPaymentValue := JS.toNumber(lRetval.ResultAsObject['value']);

  lRetVal := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      SC_GetPaymentCountByPaymentMethod,
      [Payment_Method[TPaymentMethod.Cheque], FromDateString, ToDateString]
    )
  );
  ChequeTableData.TotalPaymentCount := JS.toInteger(lRetval.ResultAsObject['value']);

  lRetVal := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      SC_GetPaymentMethodSchoolCountBetweenDates,
      [Payment_Method[TPaymentMethod.Cheque], FromDateString, ToDateString]
    )
  );
  ChequeTableData.TotalSchoolCount := JS.toInteger(lRetval.ResultAsObject['value']);

  lRetVal := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      SC_GetPaymentMethodSchoolCountByKindBetweenDates,
      [Payment_Method[TPaymentMethod.Cheque], School_Kind[TSchoolKind.Primary], FromDateString, ToDateString]
    )
  );
  ChequeTableData.PrimaryCount := JS.toInteger(lRetval.ResultAsObject['value']);

  lRetVal := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      SC_GetPaymentMethodSchoolCountByKindBetweenDates,
      [Payment_Method[TPaymentMethod.Cheque], School_Kind[TSchoolKind.Secondary], FromDateString, ToDateString]
    )
  );
  ChequeTableData.SecondaryCount := JS.toInteger(lRetval.ResultAsObject['value']);

  lRetVal := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      SC_GetPaymentMethodSchoolCountByKindBetweenDates,
      [Payment_Method[TPaymentMethod.Cheque], School_Kind[TSchoolKind.Independent], FromDateString, ToDateString]
    )
  );
  ChequeTableData.IndependentCount := JS.toInteger(lRetval.ResultAsObject['value']);

end;



end.
